<template>
  <div>
    <!-- 历史记录 -->
    <el-dialog :title="$t('message.historyRemark')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="780px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!--时间-->
            <li class="flex05">{{ $t('message.time') }}</li>
            <!--内容-->
            <li class="flex15">{{ $t('message.content') }}</li>
            <!--查看情况  -->
            <li>{{ $t('message.viewSituation') }}</li>
          </ol>
          <ul v-for="(item, index) in itemDetail.order_detail_notes" :key="index">
            <!--时间-->
            <li class="flex05">{{ item.created_at }}</li>
            <!--内容-->
            <li class="flex15">{{ item.remark }}</li>
            <!--查看情况  -->
            <li>
              <div class="template">
                <p v-for="(items, indexs) in item.read_log" :key="indexs">
                  {{ items.admin_name }} <el-tag size="mini" :type="items.readed_at ? 'success' : 'danger'">{{
                    items.readed_at ? '已查看' : '未查看' }}</el-tag>
                </p>
              </div>
            </li>
          </ul>
          <div class="noData" v-if="itemDetail.order_detail_notes == false">
            暂无历史记录
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    itemDetail: { type: Object }
  },
  data() {
    return {

      dialogVisible: false,
    };
  },
  methods: {

    // 保存
    save() {
      this.dialogVisible = false

    },
  },

};
</script>
<style lang='scss' scoped>
/deep/.el-radio__input {
  transform: scale(1.5);
}

.content {
  margin: 0px 15px;



  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }


    }

    li {
      border-right: 1px solid #edeff4;
      padding: 10px 5px;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.35;
      text-align: center;
    }

    .flex15 {
      flex: 1.5;
    }

    .template {
      width: 100%;
      text-align: left;

      p {
        margin-bottom: 5px;

        &:nth-last-child(1) {
          margin: 0;
        }
      }
    }
  }

  .noData {
    margin: 20px;
    text-align: center;
  }
}
</style>